import { render } from "./FooterBar.vue?vue&type=template&id=3ea06772&scoped=true&ts=true"
import script from "./FooterBar.vue?vue&type=script&lang=ts"
export * from "./FooterBar.vue?vue&type=script&lang=ts"

import "./FooterBar.vue?vue&type=style&index=0&id=3ea06772&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@5.9.3__webpack@5.108.4_postcss@8.5.22_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea06772"]])

export default __exports__